const MORE_VIDEOS_PREFIX = 'mplayer-more-videos';

const LARGE_GALLERY_VIEW = 'large-gallery';
const SMALL_GALLERY_VIEW = 'small-gallery';
const INSIDE_GALLERY = 'inside-gallery';
const OUTSIDE_GALLERY = 'outside-gallery';

const MORE_VIDEOS_BUTTON = 'more-videos-button';
const CLOSE_BUTTON = 'close-button';
const RIGHT_ARROW = 'right-arrow';
const LEFT_ARROW = 'left-arrow';
const VIDEO_UNIT = 'video-unit';

export const getInsideGalleryMoreVideosButtonId = (playerId: string): string => `${MORE_VIDEOS_PREFIX}-${INSIDE_GALLERY}-${MORE_VIDEOS_BUTTON}-${playerId}`;

export const getOutsideGalleryMoreVideosButtonId = (playerId: string): string => `${MORE_VIDEOS_PREFIX}-${OUTSIDE_GALLERY}-${MORE_VIDEOS_BUTTON}-${playerId}`;

export const getLargeGalleryCloseButtonId = (playerId: string): string => `${MORE_VIDEOS_PREFIX}-${LARGE_GALLERY_VIEW}-${CLOSE_BUTTON}-${playerId}`;

export const getSmallGalleryCloseButtonId = (playerId: string): string => `${MORE_VIDEOS_PREFIX}-${SMALL_GALLERY_VIEW}-${CLOSE_BUTTON}-${playerId}`;

export const getLargeGalleryRightArrowId = (playerId: string): string => `${MORE_VIDEOS_PREFIX}-${LARGE_GALLERY_VIEW}-${RIGHT_ARROW}-${playerId}`;

export const getSmallGalleryRightArrowId = (playerId: string): string => `${MORE_VIDEOS_PREFIX}-${SMALL_GALLERY_VIEW}-${RIGHT_ARROW}-${playerId}`;

export const getLargeGalleryLeftArrowId = (playerId: string): string => `${MORE_VIDEOS_PREFIX}-${LARGE_GALLERY_VIEW}-${LEFT_ARROW}-${playerId}`;

export const getSmallGalleryLeftArrowId = (playerId: string): string => `${MORE_VIDEOS_PREFIX}-${SMALL_GALLERY_VIEW}-${LEFT_ARROW}-${playerId}`;

export const getLargeGalleryVideoUnitId = (index: number, playerId: string): string => `${MORE_VIDEOS_PREFIX}-${LARGE_GALLERY_VIEW}-${VIDEO_UNIT}-${index}-${playerId}`;

export const getSmallGalleryVideoUnitId = (playerId: string): string => `${MORE_VIDEOS_PREFIX}-${SMALL_GALLERY_VIEW}-${VIDEO_UNIT}-${playerId}`;
